"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _utils = require("../../utils");

var TbodyWithoutDocs = (0, _context.styledWithTheme)('tbody')(function (_ref) {
  var theme = _ref.theme;
  return {
    fontSize: (0, _utils.px)(theme.selectors.fontSize('T200'))
  };
});
var Tbody = (0, _stencilReactDesc.describe)(TbodyWithoutDocs).description("Stencil-styled HTML 'tbody' element.");
Tbody.propTypes = {};
Tbody.displayName = 'Tbody';
var _default = Tbody;
exports.default = _default;